import { FormAutocomplete as FormAutocompleteDS } from '@gov-design-system-ce/react-form';
import { type FormAutocompleteProps as FormAutocompletePropsDS } from '@gov-design-system-ce/react-form';
import { MessageWrapper } from './MessageWrapper';

export type FormAutocompleteProps<T extends object> = Omit<
	FormAutocompletePropsDS<T>,
	'messageWrapper' | 'classNames'
>;

const DEFAULT_MESSAGES = { messages: [] };

export const FormAutocomplete = <T extends object>(
	props: FormAutocompleteProps<T>
) => (
	<FormAutocompleteDS
		{...props}
		label={{ size: 'm', ...props.label }}
		field={{ size: 'm', ...props.field }}
		messages={props.messages ?? DEFAULT_MESSAGES}
		messageWrapper={MessageWrapper}
	/>
);
